import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import middleware from '@@/.nuxt/middleware';
middleware['nuxt-custom-headers'] = context => {
  if (process.server) {
    var headers = [].concat.apply([], context.route.matched.map(_ref => {
      var {
        components
      } = _ref;
      return Object.values(components);
    })).reduce((headers, component) => {
      if (component.options && component.options[context.env.NUXT_CUSTOM_HEADERS_FUNCTION]) {
        Object.assign(headers, component.options[context.env.NUXT_CUSTOM_HEADERS_FUNCTION](context));
      }
      return headers;
    }, {});
    Object.keys(headers).map(function (header) {
      context.res.setHeader(header, headers[header]);
    });
  }
};